import { t } from '@lingui/macro';
import { Button, MagnifierIcon } from '@onsolve/onsolve-ui-components';
import React from 'react';
const GlobalSearchIcon = ({ handleClick }) => (<div className="onsolve-header-search-icon">
        <Button data-test="btn-global-search" className="p-2" color="transparent" onClick={handleClick} aria-label={t `Search Icon`}>
            <MagnifierIcon className="pointer" color="white"/>
        </Button>
    </div>);
GlobalSearchIcon.displayName = 'GlobalSearchIcon';
export default GlobalSearchIcon;
